import React, { useCallback, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { Breadcrumb, message } from "antd";
import gql from "fraql";
import { get } from "lodash";
import ReportTableDisplayResults from "../utils/ReportTableDisplayResults";
import LayoutPageHeader from "../../LayoutPageHeader";
import ReportDataExportButton from "../ReportDataExportButton";
import TeamSummaryReportForm from "./TeamSummaryReportForm";
import "../SummaryReportPage.scss";

const GET_TEAM_SUMMARY_REPORT = gql`
  query TeamSummaryReportPage_GetTeamSummaryReport($CompetitionIds: [ID!]!) {
    TeamSummaryReport(competitionIds: $CompetitionIds) {
      result
    }
  }
`;

function TeamSummaryReportPage() {
  const [getReport, { loading, data, error }] = useLazyQuery(GET_TEAM_SUMMARY_REPORT, {
    onError: err => {
      console.error(err);
      message.error("Failed to generate the report.");
    },
  });

  const reportData = useMemo(() => get(data, "TeamSummaryReport.result", null), [data]);

  const tableColumns = [
    { title: "Sport", dataIndex: "Sport", key: "Sport" },
    { title: "Competition", dataIndex: "Competition", key: "Competition" },
    { title: "Age group", dataIndex: "AgeGroup", key: "AgeGroup" },
    { title: "Number of Teams", dataIndex: "TeamCount", key: "TeamCount" },
    { title: "Number of Players", dataIndex: "PlayerCount", key: "PlayerCount" },
  ];

  const handleSubmitForm = useCallback(
    async (values, actions) => {
      const { CompetitionIds } = values;
      getReport({ variables: { CompetitionIds } });
      actions.setSubmitting(false);
    },
    [getReport],
  );
  
  const [filteredRows, setFilteredRows] = useState([]);
    const filteredRowKeys = useMemo(() => {
      return filteredRows.map(row => row.key);
    }, [filteredRows]);

  let actions;

  if (reportData) {
    actions = (
      <>
        <ReportDataExportButton
          title="Team Summary Report"
          data={{ rows: reportData, columns: tableColumns.map(column => column.dataIndex) }}
          selectedRowKeys={filteredRowKeys}
          disabled={loading}
        />
      </>
    );
  } else {
    actions = null;
  }

  return (
    <>
      <div
        style={{
          borderBottom: "2px solid #e8e8e8",
          padding: "15px 24px",
        }}
      >
        <Breadcrumb style={{ marginBottom: 10 }}>
          <Breadcrumb.Item>Reports</Breadcrumb.Item>
          <Breadcrumb.Item>Team Summary Report</Breadcrumb.Item>
        </Breadcrumb>

        <LayoutPageHeader title="Team Summary Report" extra={actions} />
      </div>

      <div className="summary-report__container">
        <div className="summary-report__flex-container">
          <div className="summary-report__left-sidebar">
            <div className="summary-report__left-sidebar-content">
              <TeamSummaryReportForm handleSubmit={handleSubmitForm} />
            </div>
          </div>
          <div className="summary-report__content">
            <ReportTableDisplayResults data={reportData} loading={loading} error={error} columns={tableColumns} setFilteredRows={setFilteredRows} />
          </div>
        </div>
      </div>
    </>
  );
}

export default TeamSummaryReportPage;
